import { render, staticRenderFns } from "./FileResultCard.vue?vue&type=template&id=4ab4e368"
import script from "./FileResultCard.vue?vue&type=script&lang=ts"
export * from "./FileResultCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports